import * as React from 'react';

import { SelectionPanelContainer } from 'src/components/dataSourceSelection/SelectionPanelContainer';
import { DataSourceType } from 'src/constants/dataSourceTypeDescription';
import { TEST_IDS } from 'src/constants/testIds';
import { ConnectionCardV2 } from 'src/containers/ProjectVirtualGraphPreviewDialogV2/components/ConnectionCardV2';
import { DataSource } from 'src/store/state/dataSources';
import * as copy from 'src/templates/copy';

export type ConnectionSelectionStepProps = {
  /** The type of data source being selected */
  dataSourceType: DataSourceType;
  /** List of existing data sources of this type */
  dataSources: DataSource[];
  /** Whether a connection operation is in progress */
  isLoading?: boolean;
  /** Callback when user selects "New Connection" */
  onSelectNewConnection: () => void;
  /** Callback when user selects an existing data source */
  onSelectDataSource: (dataSource: DataSource) => void;
};

/**
 * A reusable component for selecting data source connections.
 * Displays a "New Connection" card and a list of existing data sources.
 */
export const ConnectionSelectionStep: React.VFC<
  ConnectionSelectionStepProps
> = ({
  dataSourceType,
  dataSources,
  isLoading,
  onSelectNewConnection,
  onSelectDataSource,
}) => {
  return (
    <SelectionPanelContainer
      isLoading={isLoading}
      subtitle={
        copy.components.virtualGraphPreviewDialog.connectionSelection.subtitle
      }
      testId={TEST_IDS.projectResourceDialogV2.connectionSelection.container}
    >
      {/* New Connection Card */}
      <div
        data-testid={
          TEST_IDS.projectResourceDialogV2.connectionSelection.newConnectionCard
        }
      >
        <ConnectionCardV2
          dataSource={null}
          dataSourceType={dataSourceType}
          isNewConnection
          onSelect={onSelectNewConnection}
        />
      </div>

      {/* Existing Connections */}
      {dataSources.map((dataSource) => (
        <ConnectionCardV2
          key={dataSource.id}
          dataSource={dataSource}
          dataSourceType={dataSourceType}
          onSelect={() => onSelectDataSource(dataSource)}
        />
      ))}
    </SelectionPanelContainer>
  );
};
